<div class="header">
    <h2>People</h2>

    @if (uniqueInactiveConnections.size > 0) {
        <div class="buttons">
            <button class="btn btn-pill btn-toolbar"
                    [ngClass]="showInactiveConnections ? 'active' : ''"
                    [adaptButtonIcon]="showInactiveConnections ? 'fal fa-eye-slash' : 'fal fa-eye'"
                    (click)="showInactiveConnections = !showInactiveConnections">{{ showInactiveConnections ? "Hide" : "Show" }} previous
                people</button>
        </div>
    }
</div>

<div class="role-people-panel">
    @if (uniqueActiveConnections.size === 0 && !showInactiveConnections) {
        <p>No people are currently allocated to this role.</p>
    }
    <div class="role-people">
        @for (connection of uniqueActiveConnections; track connection.connectionId) {
            <div class="d-flex flex-row gap-2 align-items-center">
                <adapt-link-person [person]="connection.person"
                                   [showImage]="true"
                                   class="role-people-position"></adapt-link-person>
                @if (activeRoleConnectionForConnection.get(connection); as roleConnection) {
                    <adapt-display-role-connection-handover-status [roleConnection]="roleConnection">
                    </adapt-display-role-connection-handover-status>
                }
            </div>
        }
    </div>

    @if (showInactiveConnections) {
        <h3 class="mt-3">Previous People</h3>
    }
    @if (showInactiveConnections) {
        <div class="role-people">
            @for (connection of uniqueInactiveConnections; track connection.connectionId) {
                <adapt-link-person [person]="connection.person"
                                   [showImage]="true"
                                   class="role-people-position"></adapt-link-person>
            }
        </div>
    }
</div>
